import { jsx as _jsx } from "react/jsx-runtime";
import { Header, HeaderInner, HeaderTitle } from "../AppSwitcher.components.js";
export const AppSwitcherMenuHeaderComponent = ({ title, ...props }) => (_jsx(Header, { "data-testid": "AppSwitcherMenuHeader", ...props, children: _jsx(HeaderInner, { children: title?.trim() && (_jsx(HeaderTitle, { variant: "headline", size: "small", component: "div", children: title })) }) }));
export default AppSwitcherMenuHeaderComponent;
